import React, { useState, useEffect, useCallback } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { Tooltip } from '@mui/material';
import { MenuItem, Select, FormControl, InputLabel } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle'; // Ícone para "finalizar"
import IconButton from '@mui/material/IconButton';


import AddIcon from '@mui/icons-material/Add';
import DoneIcon from '@mui/icons-material/Done';
import TextField from '@material-ui/core/TextField';
import RefreshIcon from '@mui/icons-material/Refresh';
import Cookies from 'js-cookie';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import AppBar from '@mui/material/AppBar';
import Box from '@material-ui/core/Box';
import { useHistory } from "react-router-dom";
import moment from 'moment';
import { useParams } from "react-router-dom";
import SwipeableViews from 'react-swipeable-views';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Collapse from '@material-ui/core/Collapse';
import Paper from '@material-ui/core/Paper';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Skeleton from '@material-ui/lab/Skeleton';
import { styled } from '@material-ui/styles';
import { Card, CardContent } from '@mui/material';
import { Link } from 'react-router-dom';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import CheckIcon from '@mui/icons-material/Check';
import { useDropzone } from 'react-dropzone';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CancelIcon from '@mui/icons-material/Cancel';
import {

  Divider,
  Avatar,
  Chip
} from '@mui/material';
import {
  Security as SecurityIcon,
  AcUnit as RefrigerationIcon,
  Person as PersonIcon,
  Place as PlaceIcon,
  Description as DescriptionIcon,
  Work as ProjectIcon
} from '@mui/icons-material';
  
  import {
    DataGrid,  
    GridToolbarContainer,
    GridToolbarColumnsButton,
    GridToolbarFilterButton,
    GridToolbarExport,
    GridToolbarDensitySelector,
} from '@mui/x-data-grid';
import { AddToQueueOutlined, LaptopWindows } from '@material-ui/icons';

 
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'; // Ícone apropriado
import ComputerOutlinedIcon from '@mui/icons-material/ComputerOutlined';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import EngineeringOutlinedIcon from '@mui/icons-material/EngineeringOutlined';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import ChecklistOutlinedIcon from '@mui/icons-material/ChecklistOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';


import miniatura_pdf from '../../../../../assets/imgs/miniatura_pdf.png';
import api from '../../../../../services/api';


const ColorButtonBlue = styled(Button)(({ theme }) => ({
    color: 'white',
    backgroundColor: 'blue',
    borderColor: 'black',
    '&:hover': {
        backgroundColor: 'blue',
        color: 'whit',
        borderColor: 'red',
    },
}));


const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        '& .cabecalho_transparente': {
            backgroundColor: 'rgba(0, 0, 0, 0)',
            color: 'rgba(0, 0, 0, 0)',
        },
        '& .cabecalho_azul': {
            backgroundColor: 'rgba(0, 0, 255, 1)',
            color: 'white',
        },
        '& .cabecalho_verde': {
            backgroundColor: 'rgba(0, 100, 0, 1)',
            color: 'white',
        },
        '& .cabecalho_verde_claro': {
            backgroundColor: 'rgba(107,142,35, 1)',
            color: 'white',
        },
        '& .cabecalho_marrom_claro': {
            backgroundColor: 'rgba(184,134,11, 1)',
            color: 'white',
        },
        '& .cabecalho_verde_cyan': {
            backgroundColor: 'rgba(0,139,139, 1)',
            color: 'white',
        },
        '& .cabecalho_verde_dark_sea': {
            backgroundColor: 'rgba(60,179,113, 1)',
            color: 'white',
        },
        '& .cabecalho_marrom_escuro': {
            backgroundColor: 'rgba(139,69,19, 1)',
            color: 'white',
        },
        '& .cabecalho_marrom_chocolate': {
            backgroundColor: 'rgba(210,105,30, 1)',
            color: 'white',
        },
        '& .cabecalho_darkslate': {
            backgroundColor: 'rgba(47,79,79, 1)',
            color: 'white',
        },
        '& .super-app.negative': {
            backgroundColor: 'rgba(157, 255, 118, 0.49)',
            color: '#1a3e72',
            fontWeight: '600',
        },
        '& .super-app.positive': {
            backgroundColor: '#d47483',
            color: '#1a3e72',
            fontWeight: '600',
        },
        '& .super-app.neutro': {
            backgroundColor: '#363636',
            color: 'white',
            fontWeight: '600',
        },
    },

    toolbar: {
        paddingRight: 24, // keep right padding when drawer closed
    },
    toolbarIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px',
        ...theme.mixins.toolbar,
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: 36,
    },
    menuButtonHidden: {
        display: 'none',
    },
    title: {
        flexGrow: 1,
    },
    drawerPaper: {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9),
        },
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: 240,
    },
}));

const ColorButtonRed = styled(Button)(({ theme }) => ({
    color: 'white',
    backgroundColor: 'red',
    borderColor: 'black',
    '&:hover': {
        backgroundColor: 'red',
        color: 'whit',
        borderColor: 'blue',
    },
}));



const ColorButtonGreen = styled(Button)(({ theme }) => ({
    color: 'white',
    backgroundColor: 'green',
    borderColor: 'black',
    '&:hover': {
        backgroundColor: 'green',
        color: 'whit',
        borderColor: 'blue',
    },
}));




const dropzoneStyles = {
    border: '4px dashed #000000',
    borderRadius: '4px',
    padding: '2px',
    textAlign: 'center',
    cursor: 'pointer',
    margin: '2px 0',
};



export default function CabecalhoInformacoes({ projeto}) {

    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);

    }


    const handleChangeIndex = (index) => {
        setValue(index);
    };


    function returnDescricaoCliente(cliente) {
           var texto =
               (cliente.tipo_cliente === 0 ? (cliente.nome + " " + cliente.sobrenome) : cliente.nome_fantasia);
   
           return texto;
       }

        function returnDescricaoInstalacao(instalacao) {
               var texto =  (instalacao.tipo_instalacao === 0 ? (instalacao.nome + " " + instalacao.sobrenome) : instalacao.nome_fantasia);
       
               return texto;
           }
       

             async function baixarArquivo(caminho) {
                   try {
                       const token = Cookies.get('token');
                       const headers = {
                           'Authorization': 'Bearer ' + token
                       }
           
                       const response = await api.post("/v1/protected/projetos/baixarPdf", { caminho: encodeURIComponent(caminho) }, {
                           headers: headers,
                           responseType: 'arraybuffer',  // Indica que a resposta é um array de bytes
                       });
           
                       // Cria um blob com os dados recebidos
                       const blob = new Blob([response.data], { type: 'application/pdf' });
           
                       // Cria uma URL do blob
                       const blobUrl = URL.createObjectURL(blob);
           
                       // Abre uma nova guia com o arquivo PDF
                       window.open(blobUrl, '_blank');
                   } catch (error) {
                       // Trate os erros conforme necessário
                       window.alert("Erro ao baixar o arquivo: " + error);
                   }
               }
           
 

    return (
        <div>
            <Grid  
                alignItems="center"
                justifyContent="center"
            >

                <Grid
                    item xs={12}
                    container
                    direction="row"
                    alignItems="center"
                    justifyContent={"center"}
                    style={{ marginRight: 10, marginLeft: 10 }}
                >


                    <Box style={{ backgroundColor: 'white', width: '100%', alignItems: 'center', }}>
                        <AppBar position="static" >

                            <Tabs
                                value={value}
                                onChange={handleChange}
                                indicatorColor="secondary"
                                textColor="inherit"
                                variant="scrollable"
                                scrollButtons="auto"
                                aria-label="scrollable auto tabs example"


                            >
                                <Tab label="Dados" style={{ backgroundColor: '#1C1C1C' }} />
                                <Tab label="Imagens" style={{ backgroundColor: 'green' }} />
                                <Tab label="Vídeos" style={{ backgroundColor: 'green' }} />
                                <Tab label="Documentos" style={{ backgroundColor: 'green' }} />

                            </Tabs>
                        </AppBar>

                    </Box>
                </Grid>

                <SwipeableViews
                    index={value}
                    onChangeIndex={handleChangeIndex}
                    style={{ backgroundColor: 'white', width: '100%', alignItems: 'center', }}
                >
  <Grid
  style={{  padding: 50 }}
  container
  direction="row"
  item
  xs={12}
  alignItems="center"
  justifyContent="center"
  spacing={2}
  value={value}
  index={0}
  component={Paper}
  elevation={3}
  sx={{ p: 3, borderRadius: 2 }}
>
  {/* Cabeçalho */}
  <Grid item xs={12}>
    <Box display="flex" alignItems="center" mb={2} pl={2}>
      <Avatar sx={{ bgcolor: 'primary.main', mr: 2 }}>
        <ProjectIcon />
      </Avatar>
      <Typography variant="h6" component="div" fontWeight="bold">
        Projeto
      </Typography>
    </Box>
    <Divider />
  </Grid>

  {/* Área do Projeto */}
  <Grid item xs={12} >
    <FormControl fullWidth>
      <InputLabel shrink sx={{ fontWeight: 'bold' }} id="area-selector-label">Área do Projeto</InputLabel>
      <Select
        labelId="area-selector-label"
        id="area-selector"
        value={projeto.area}
        displayEmpty
        variant="outlined"
      >
        <MenuItem value={0}>
          <Box display="flex" alignItems="center">
            <SecurityIcon color="primary" sx={{ mr: 1 }} />
            Segurança
          </Box>
        </MenuItem>
        <MenuItem value={1}>
          <Box display="flex" alignItems="center">
            <RefrigerationIcon color="secondary" sx={{ mr: 1 }} />
            Refrigeração
          </Box>
        </MenuItem>
      </Select>
    </FormControl>
  </Grid>

  {/* Cliente e Instalação */}
  <Grid item xs={12} md={6}>
    <Autocomplete
      id="select-cliente"
      options={[]}
      disableCloseOnSelect
      getOptionLabel={(cliente) => returnDescricaoCliente(cliente).replace(/<br \/>/g, '\n')}
      value={projeto.cliente}
      filterOptions={(options, { inputValue }) => {
        const inputKeywords = inputValue.toLowerCase().split(" ");
        return options.filter((cliente) => {
          const cotacaoText = returnDescricaoCliente(cliente).toLowerCase();
          return inputKeywords.every((keyword) => cotacaoText.includes(keyword));
        });
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Cliente"
          variant="outlined"
          InputLabelProps={{ shrink: true, style: { fontWeight: 'bold' } }}
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <>
                <PersonIcon color="action" sx={{ mr: 1 }} />
                {params.InputProps.startAdornment}
              </>
            )
          }}
        />
      )}
      renderOption={(props, option) => (
        <Box component="li" {...props}>
          <div dangerouslySetInnerHTML={{ __html: returnDescricaoCliente(option) }} />
        </Box>
      )}
    />
  </Grid>

  <Grid item xs={12} md={6}>
    <Autocomplete
      id="select-instalacao"
      options={[]}
      disableCloseOnSelect
      getOptionLabel={(instalacao) => returnDescricaoInstalacao(instalacao).replace(/<br \/>/g, '\n')}
      value={projeto.instalacao}
      filterOptions={(options, { inputValue }) => {
        const inputKeywords = inputValue.toLowerCase().split(" ");
        return options.filter((instalacao) => {
          const cotacaoText = returnDescricaoInstalacao(instalacao).toLowerCase();
          return inputKeywords.every((keyword) => cotacaoText.includes(keyword));
        });
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Instalação"
          variant="outlined"
          InputLabelProps={{ shrink: true, style: { fontWeight: 'bold' } }}
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <>
                <PlaceIcon color="action" sx={{ mr: 1 }} />
                {params.InputProps.startAdornment}
              </>
            )
          }}
        />
      )}
      renderOption={(props, option) => (
        <Box component="li" {...props}>
          <div dangerouslySetInnerHTML={{ __html: returnDescricaoInstalacao(option) }} />
        </Box>
      )}
    />
  </Grid>

  {/* Nome do Projeto */}
  <Grid item xs={12} md={6}>
    <TextField
      variant="outlined"
      name="nomeProjeto"
      label="Nome do Projeto"
      required
      fullWidth
      value={projeto.nome_projeto}
      InputLabelProps={{ shrink: true, style: { fontWeight: 'bold' } }}
      InputProps={{
        startAdornment: (
          <DescriptionIcon color="action" sx={{ mr: 1 }} />
        )
      }}
    />
  </Grid>

  {/* Descrição do Projeto */}
  <Grid item xs={12}>
    <TextField
      variant="outlined"
      name="descricaoProjeto"
      label="Descrição do Projeto"
      required
      fullWidth
      multiline
      minRows={4}
      value={projeto.descricao_projeto}
      InputLabelProps={{ shrink: true, style: { fontWeight: 'bold' } }}
      InputProps={{
        startAdornment: (
          <DescriptionIcon color="action" sx={{ mr: 1, alignSelf: 'flex-start' }} />
        )
      }}
    />
  </Grid>
</Grid>
                   
                                              <Grid
                                                value={value} index={1}
                                                container
                                                direction="row"
                                                item xs={12}
                                                alignItems="center"
                                                justifyContent="center"
                                            >
                    
                    
                                                <Grid item xs={8}
                                                    container
                                                    alignItems="center"
                                                    justifyContent="center"
                                                >
                    
                                                    <Grid item xs={12}
                                                        container
                                                        alignItems="center"
                                                        justifyContent="center"
                                                    >
                                                        <Grid item xs={12} style={{ paddingTop: 10, paddingBottom: 10 }}>
                                                            {
                                                                projeto.caminho_imagem1 &&
                                                                <Typography
                                                                    variant="h7"
                                                                >
                                                                    {"Descrição: " + projeto.descricao_imagem1}
                                                                </Typography>
                                                            }
                    
                                                        </Grid>
                                                        <Grid item xs={12}
                                                            container
                                                            style={{ paddingBottom: 30 }}
                                                        >
                                                            {projeto.caminho_imagem1 &&
                                                                <img
                                                                    style={{ maxWidth: '100%', maxHeight: '100%' }}
                                                                    src={ projeto.caminho_imagem1.replace("/home/wwgrup/projetos/", "https://gruporosinetos.com/projetosmidias/") } alt="Imagem 1" />
                                                            }
                                                        </Grid>
                    
                                                    </Grid>

                                                    <Grid
                                                    container
                                                        alignItems="center"
                                                        justifyContent="center"
                                                    >
                                                        <Grid item xs={12} style={{ paddingTop: 10, paddingBottom: 10 }}>
                                                            {
                                                                projeto.caminho_imagem2 &&
                                                                <Typography
                                                                    variant="h7"
                                                                >
                                                                    {"Descrição: " + projeto.descricao_imagem2}
                                                                </Typography>
                                                            }
                    
                                                        </Grid>
                                                        <Grid item xs={12}
                                                            container
                                                            style={{ paddingBottom: 30 }}
                                                        >
                                                            {projeto.caminho_imagem2 &&
                                                                <img
                                                                    style={{ maxWidth: '100%', maxHeight: '100%' }}
                                                                    src={ projeto.caminho_imagem2.replace("/home/wwgrup/projetos/", "https://gruporosinetos.com/projetosmidias/") } alt="Imagem 1" />
                                                            }
                                                        </Grid>
                    
                                                    </Grid>
                    
                                                    <Grid
                                                    container
                                                        alignItems="center"
                                                        justifyContent="center"
                                                    >
                                                        <Grid item xs={12} style={{ paddingTop: 10, paddingBottom: 10 }}>
                                                            {
                                                                projeto.caminho_imagem3 &&
                                                                <Typography
                                                                    variant="h7"
                                                                >
                                                                    {"Descrição: " + projeto.descricao_imagem3}
                                                                </Typography>
                                                            }
                    
                                                        </Grid>
                                                        <Grid item xs={12}
                                                            container
                                                            style={{ paddingBottom: 30 }}
                                                        >
                                                            {projeto.caminho_imagem3 &&
                                                                <img
                                                                    style={{ maxWidth: '100%', maxHeight: '100%' }}
                                                                    src={ projeto.caminho_imagem3.replace("/home/wwgrup/projetos/", "https://gruporosinetos.com/projetosmidias/") } alt="Imagem 1" />
                                                            }
                                                        </Grid>
                    
                                                    </Grid>
                    
                                                   <Grid
                                                    container
                                                        alignItems="center"
                                                        justifyContent="center"
                                                    >
                                                        <Grid item xs={12} style={{ paddingTop: 10, paddingBottom: 10 }}>
                                                            {
                                                                projeto.caminho_imagem4 &&
                                                                <Typography
                                                                    variant="h7"
                                                                >
                                                                    {"Descrição: " + projeto.descricao_imagem14}
                                                                </Typography>
                                                            }
                    
                                                        </Grid>
                                                        <Grid item xs={12}
                                                            container
                                                            style={{ paddingBottom: 30 }}
                                                        >
                                                            {projeto.caminho_imagem4 &&
                                                                <img
                                                                    style={{ maxWidth: '100%', maxHeight: '100%' }}
                                                                    src={ projeto.caminho_imagem4.replace("/home/wwgrup/projetos/", "https://gruporosinetos.com/projetosmidias/") } alt="Imagem 4" />
                                                            }
                                                        </Grid>
                    
                                                    </Grid>
                    
                    
                    
                                                   
                    
                    
                                                </Grid>
                    
                                            </Grid>

                                               <Grid
                                                                                        value={value} index={2}
                                                                                        container
                                                                                        direction="row"
                                                                                        item xs={12}
                                                                                        alignItems="center"
                                                                                        justifyContent="center"
                                                                                    >
                                            
                                            
                                            
                                                                                        <Grid item xs={12}
                                                                                            container
                                                                                            alignItems="center"
                                                                                            justifyContent="center"
                                                                                        >
                                            
                                                                                            <Grid item xs={4}
                                                                                                container
                                                                                                alignItems="center"
                                                                                                justifyContent="center"
                                                                                            >
                                                                                                <Grid item xs={12} style={{ paddingTop: 10, paddingBottom: 10 }}>
                                                                                                    {
                                                                                                        projeto.video1 &&
                                                                                                        <Typography
                                                                                                            variant="h7"
                                                                                                        >
                                                                                                            {"Descrição: " + projeto.descricao_video1}
                                                                                                        </Typography>
                                                                                                    }
                                            
                                                                                                </Grid>
                                                                                                <Grid item xs={12}
                                                                                                    container
                                                                                                    style={{ paddingBottom: 30 }}
                                                                                                >
                                                                                                    {projeto.video1 &&
                                                                                                        <video controls width="400" height="300">
                                                                                                            <source
                                                                                                                type="video/mp4"  // ajuste o tipo de mídia conforme necessário (por exemplo, video/mp4, video/webm, etc.)
                                                                                                                src={`data:video/mp4;base64,${projeto.video1}`}
                                                                                                            />
                                                                                                            Seu navegador não suporta o elemento de vídeo.
                                                                                                        </video>
                                            
                                                                                                    }
                                                                                                </Grid>
                                            
                                                                                            </Grid>
                                            
                                            
                                                                                            <Grid item xs={4}
                                                                                                container
                                                                                                alignItems="center"
                                                                                                justifyContent="center"
                                                                                            >
                                                                                                <Grid item xs={12}
                                                                                                    style={{ paddingTop: 10, paddingBottom: 10 }}
                                                                                                >
                                                                                                    {
                                                                                                        projeto.video2 &&
                                                                                                        <Typography
                                                                                                            variant="h7"
                                                                                                        >
                                                                                                            {"Descrição: " + projeto.descricao_video2}
                                                                                                        </Typography>
                                                                                                    }
                                            
                                                                                                </Grid>
                                                                                                <Grid item xs={12}
                                                                                                    container
                                                                                                    style={{ paddingBottom: 30 }}
                                                                                                >
                                                                                                    {projeto.video2 &&
                                                                                                        <video controls width="400" height="300">
                                                                                                            <source
                                                                                                                type="video/mp4"  // ajuste o tipo de mídia conforme necessário (por exemplo, video/mp4, video/webm, etc.)
                                                                                                                src={`data:video/mp4;base64,${projeto.video2}`}
                                                                                                            />
                                                                                                            Seu navegador não suporta o elemento de vídeo.
                                                                                                        </video>
                                                                                                    }
                                                                                                </Grid>
                                            
                                                                                            </Grid>
                                            
                                            
                                                                                            <Grid item xs={4}
                                                                                                container
                                                                                                alignItems="center"
                                                                                                justifyContent="center"
                                                                                            >
                                                                                                <Grid item xs={12}
                                                                                                    style={{ paddingTop: 10, paddingBottom: 10 }}
                                                                                                >
                                                                                                    {
                                                                                                        projeto.video3 &&
                                                                                                        <Typography
                                                                                                            variant="h7"
                                                                                                        >
                                                                                                            {"Descrição: " + projeto.descricao_video3}
                                                                                                        </Typography>
                                                                                                    }
                                            
                                                                                                </Grid>
                                                                                                <Grid item xs={12}
                                                                                                    container
                                                                                                    style={{ paddingBottom: 30 }}
                                                                                                >
                                                                                                    {projeto.video3 &&
                                                                                                        <video controls width="400" height="300">
                                                                                                            <source
                                                                                                                type="video/mp4"  // ajuste o tipo de mídia conforme necessário (por exemplo, video/mp4, video/webm, etc.)
                                                                                                                src={`data:video/mp4;base64,${projeto.video3}`}
                                                                                                            />
                                                                                                            Seu navegador não suporta o elemento de vídeo.
                                                                                                        </video>
                                                                                                    }
                                                                                                </Grid>
                                            
                                                                                    
                                            
                                            
                                            
                                                </Grid>
                                                  </Grid>
                                            
                                                                                        </Grid>

                                                                                         <Grid
                                                                                        value={value} index={3}
                                                                                        container
                                                                                        direction="row"
                                                                                        item xs={12}
                                                                                        alignItems="center"
                                                                                        justifyContent="center"
                                                                                    >
                                            
                                             
                                            
                                                                                        <Grid item xs={8}
                                                                                            container
                                                                                            alignItems="center"
                                                                                            justifyContent="center"
                                                                                        >
                                            
                                                                                            <Grid item xs={4}
                                                                                                container
                                                                                                alignItems="center"
                                                                                                justifyContent="center"
                                                                                            >
                                                                                                <Grid item xs={12} style={{ paddingTop: 10, paddingBottom: 10 }}>
                                                                                                    {
                                                                                                        projeto.caminho_arquivo1 &&
                                                                                                        <Typography
                                                                                                            variant="h7"
                                                                                                        >
                                                                                                            {"Descrição: " + projeto.descricao_arquivo1}
                                                                                                        </Typography>
                                                                                                    }
                                            
                                                                                                </Grid>
                                                                                                <Grid item xs={12}
                                                                                                    container
                                                                                                    style={{ paddingBottom: 30 }}
                                                                                                >
                                                                                                    {projeto.caminho_arquivo1 &&
                                                                                                        <div
                                                                                                            onClick={() => {
                                            
                                                                                                                baixarArquivo(projeto.caminho_arquivo1);
                                            
                                            
                                                                                                            }}
                                                                                                            style={{ cursor: 'pointer', display: 'flex', justifyContent: 'center', margin: 0, width: '200px', height: '200px' }}>
                                                                                                            <img alt={'miniatura_pdf'} style={{ textAlign: 'center' }} src={miniatura_pdf}></img>
                                                                                                        </div>
                                            
                                            
                                            
                                            
                                                                                                    }
                                                                                                </Grid>
                                            
                                                                                            </Grid>
                                            
                                            
                                                                                            <Grid item xs={4}
                                                                                                container
                                                                                                alignItems="center"
                                                                                                justifyContent="center"
                                                                                            >
                                                                                                <Grid item xs={12}
                                                                                                    style={{ paddingTop: 10, paddingBottom: 10 }}
                                                                                                >
                                                                                                    {
                                                                                                        projeto.caminho_arquivo2 &&
                                                                                                        <Typography
                                                                                                            variant="h7"
                                                                                                        >
                                                                                                            {"Descrição: " + projeto.descricao_arquivo2}
                                                                                                        </Typography>
                                                                                                    }
                                            
                                                                                                </Grid>
                                                                                                <Grid item xs={12}
                                                                                                    container
                                                                                                    style={{ paddingBottom: 30 }}
                                                                                                >
                                                                                                    {projeto.caminho_arquivo2 &&
                                                                                                        <div
                                                                                                            onClick={() => {
                                            
                                                                                                                baixarArquivo(projeto.caminho_arquivo2);
                                            
                                            
                                                                                                            }}
                                                                                                            style={{ cursor: 'pointer', display: 'flex', justifyContent: 'center', margin: 0, width: '200px', height: '200px' }}>
                                                                                                            <img alt={'miniatura_pdf'} style={{ textAlign: 'center' }} src={miniatura_pdf}></img>
                                                                                                        </div>
                                            
                                            
                                            
                                                                                                    }
                                                                                                </Grid>
                                            
                                                                                            </Grid>
                                            
                                            
                                                                                            <Grid item xs={4}
                                                                                                container
                                                                                                alignItems="center"
                                                                                                justifyContent="center"
                                                                                            >
                                                                                                <Grid item xs={12}
                                                                                                    style={{ paddingTop: 10, paddingBottom: 10 }}
                                                                                                >
                                                                                                    {
                                                                                                        projeto.caminho_arquivo3 &&
                                                                                                        <Typography
                                                                                                            variant="h7"
                                                                                                        >
                                                                                                            {"Descrição: " + projeto.descricao_arquivo3}
                                                                                                        </Typography>
                                                                                                    }
                                            
                                                                                                </Grid>
                                                                                                <Grid item xs={12}
                                                                                                    container
                                                                                                    style={{ paddingBottom: 30 }}
                                                                                                >
                                                                                                    {projeto.caminho_arquivo3 &&
                                                                                                        <div
                                                                                                            onClick={() => {
                                            
                                                                                                                baixarArquivo(projeto.caminho_arquivo3);
                                            
                                            
                                                                                                            }}
                                                                                                            style={{ cursor: 'pointer', display: 'flex', justifyContent: 'center', margin: 0, width: '200px', height: '200px' }}>
                                                                                                            <img alt={'miniatura_pdf'} style={{ textAlign: 'center' }} src={miniatura_pdf}></img>
                                                                                                        </div>
                                            
                                                                                                    }
                                                                                                </Grid>
                                            
                                                                                            </Grid>
                                            </Grid>
                                            
                                            
                                            
                                                                                        </Grid>
                                            

                </SwipeableViews>

            </Grid>
 
        </div >
    );
}


